import axios from "@/app/axios";

const getStudios = () => {
  return axios.get(`api/studios`).then((res) => {
      return res.data.studios as IStudioItem[];
  });
};

const getStudio = (slug: string) => {
  return axios.get(`api/studio/${slug}`).then((res) => {
      return res.data.studio as IStudioDetails;
  });
};

const StudiosService = {
    getStudios,
    getStudio
};

export default StudiosService;
